export const DEFAULT_META_IMAGE = 'https://s.udemycdn.com/meta/default-meta-image-v2.png';
export const metadata = assetPath => ({
  brandTitle: 'Udemy',
  domain: 'www.udemy.com',
  defaultMetaImage: DEFAULT_META_IMAGE,
  appleTouchIcon: `${assetPath}/staticx/udemy/images/v7/apple-touch-icon.png`,
  brandFavIcon: `${assetPath}/staticx/udemy/images/v8/favicon-32x32.png`,
  brandFavIcon16x16: `${assetPath}/staticx/udemy/images/v8/favicon-16x16.png`,
  applicationTitleColor: '#a435f0',
  applicationTitleImage: `${assetPath}/staticx/udemy/images/v7/mstile-144x144.png`,
  applicationConfig: `${assetPath}/staticx/udemy/images/v7/browserconfig.xml`,
  manifest: `${assetPath}/staticx/udemy/images/v7/site-manifest.json`,
  appleItunesApp: 'app-id=562413829, affiliate-data=ct=Safari_SmartBanner&amp;pt=1240482',
  googlePlayApp: 'app-id=com.udemy.android.ufb',
  fbAppId: '313137469260'
});
//# sourceMappingURL=constants.js.map